import Header from "../components/Header";
import Mainsection from "../components/Mainsection";

function Homepage() {
  return (
    <div>
      <Header />
      <Mainsection />
    </div>
  );
}

export default Homepage;
